import { Skeleton } from "#/components/ui/skeleton"

export function ProfileSkeleton() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-6">
      {/* Profile Header Skeleton */}
      <div className="space-y-6 mb-8">
        <div className="flex flex-col md:flex-row gap-6 items-start">
          <Skeleton className="h-24 w-24 md:h-32 md:w-32 rounded-full" />
          <div className="flex-1 space-y-4">
            <div className="space-y-2">
              <Skeleton className="h-8 w-48" />
              <Skeleton className="h-4 w-32" />
            </div>
            <div className="flex gap-6">
              <div className="text-center">
                <Skeleton className="h-6 w-12 mb-1" />
                <Skeleton className="h-4 w-12" />
              </div>
              <div className="text-center">
                <Skeleton className="h-6 w-16 mb-1" />
                <Skeleton className="h-4 w-16" />
              </div>
              <div className="text-center">
                <Skeleton className="h-6 w-16 mb-1" />
                <Skeleton className="h-4 w-16" />
              </div>
            </div>
            <div className="flex gap-3">
              <Skeleton className="h-9 w-24" />
              <Skeleton className="h-9 w-20" />
            </div>
          </div>
        </div>
        <div className="space-y-3">
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      </div>

      {/* Tab Navigation Skeleton */}
      <div className="border-b mb-6">
        <div className="flex justify-center gap-8">
          <Skeleton className="h-10 w-16" />
          <Skeleton className="h-10 w-16" />
          <Skeleton className="h-10 w-16" />
        </div>
      </div>

      {/* Grid Skeleton */}
      <div className="grid grid-cols-3 md:grid-cols-4 gap-2 auto-rows-[120px] md:auto-rows-[150px]">
        {Array.from({ length: 12 }).map((_, i) => (
          <Skeleton key={i} className="h-full rounded-lg" />
        ))}
      </div>
    </div>
  )
}
